<template>
  <div
    class="d-flex flex-column align-center pb-15 white--text w-100 h-100 px-5"
    style="background-color: #084468;"
  >
    <div class="mb-6 d-flex align-center mt-15" style="margin-top: 30px">
      <v-img
        :src="logo"
        width="65"
        height="65"
        contain
      />
      <v-img
        :src="require('@/assets/svg/integration.svg')"
        width="30"
        height="30"
        contain
        class="mx-5"
      />
      <v-img
        :src="require('@/assets/svg/twitter.svg')"
        width="65"
        height="65"
        contain
      />
    </div>
    <v-progress-linear
      color="white accent-4"
      indeterminate
      rounded
      height="3"
      v-if="loading"
    />
    <div class="privacy_title" v-if="$route.query.oauth_token && !error">
      Authentication successful!<br /><br />
      <div class="font-18">
        Hooray! Your Twitter account is now linked. You can seamlessly post
        media to your Twitter feed right from here. Start tweeting your favorite
        moments and let your followers be a part of your journey. We're excited
        to see what you'll share!<br /><br />
        This dialog will closed shortly...
      </div>
    </div>
    <span class="privacy_title mt-6" v-else>Authentication failed</span>
    <span class="font-18 mt-6" v-if="$route.query.error">{{
      route.query.error
    }}</span>
    <span class="font-18 mt-6" v-if="error">{{ error }}</span>
  </div>
</template>
<script>
import { mapActions } from "vuex";
export default {
  data() {
    return {
      channel: new BroadcastChannel("social_connected_callback"),
      loading: false,
      error: null
    };
  },
      computed: {
    logo() {
      // resolve the logo file based on .env string
      return require(`@/assets/${process.env.VUE_APP_LOGO_WITHOUT_TEXT}`);
    }
  },
  methods: {
    ...mapActions({
      connectTwitter: "auth/connectTwitter"
    })
  },
  mounted() {
    console.log(this.$route.query.oauth_token);
    if (this.$route.query.oauth_token) {
      this.loading = true;
      this.connectTwitter({
        oauth_token: this.$route.query.oauth_token,
        oauth_verifier: this.$route.query.oauth_verifier
      })
        .then(() => {
          this.loading = false;
          this.channel.postMessage("Twitter connected successful!");
          setTimeout(() => {
            window.close();
          }, 2000);
        })
        .catch(error => {
          this.loading = false;
          console.log(error);
          if (error.response.data.res) {
            this.error = error.response.data.res;
          } else if (error.response.data.message) {
            this.error = error.response.data.message;
          } else this.error = error;
          setTimeout(() => {
            window.close();
          }, 10000);
        });
    } else {
      setTimeout(() => {
        window.close();
      }, 10000);
    }
  }
};
</script>
<style scoped>
.privacy_title {
  text-align: center;
  font-size: 24px;
  font-weight: bold;
}
</style>
